import { render, staticRenderFns } from "./DealDashboard.vue?vue&type=template&id=41ed8105&lang=pug"
import script from "./DealDashboard.vue?vue&type=script&lang=js"
export * from "./DealDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports